import { render, staticRenderFns } from "./ComplaintModal.vue?vue&type=template&id=85bb01b6&"
import script from "./ComplaintModal.vue?vue&type=script&lang=js&"
export * from "./ComplaintModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports